module.exports = __webpack_public_path__ + "static/media/mask.945457ec.svg";